import { AppThunk } from '../../../store/rootReducer';
import * as episodeMeasurementActions from '../actions/episode-measurement.actions';
import { isToolActiveSelector } from '../../tool/selectors/tool.selectors';
import { Tool } from '../../tool/utils/tool.utils';
import { isUpdatingEpisodeMeasurementSelector } from '../selectors/episode-measurement.selectors';

export const startEpisodeMeasurement =
  (timestamp: number): AppThunk =>
  async (dispatch, getState) => {
    const isUpdatingEpisodeMeasurement = isUpdatingEpisodeMeasurementSelector(
      getState(),
    );
    const isEpisodeMeasurementActive = isToolActiveSelector(
      Tool.episodeMeasurement,
    )(getState());

    if (!isUpdatingEpisodeMeasurement && isEpisodeMeasurementActive) {
      dispatch(
        episodeMeasurementActions.setBoundary({
          boundary: 'end',
          timestamp,
        }),
      );
    }
  };
